var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar",class:{ 'navbar--filled': _vm.filled }},[_c('div',{staticClass:"navbar__container px-6"},[_c('nuxt-link',{staticClass:"navbar__logo-wrapper",attrs:{"to":"/"}},[_c('InlineSvg',{staticClass:"navbar__logo h-6",attrs:{"src":_vm.logo,"alt":_vm.concept}})],1),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }